import { accountingType } from '@/features/master-table/models';
import {
  aggregationTargetTypeEnum,
  aggregationTypeEnum,
  analysisAxisEnum,
  analysisTargetEnum,
  implementationMethodEnum,
  projectCategoryEnum,
  sheetTypeEnum,
} from '@/utils/enum';
import {
  parseAsArrayOf,
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';
import { initialValueOfAnalysisSearchForm } from '../_models/analysis-search';

export const analysisSearchNuqs = {
  page: parseAsInteger.withDefault(1),
  pageSize: parseAsInteger.withDefault(30),
  analysisTarget: parseAsStringLiteral(analysisTargetEnum.options).withDefault(
    initialValueOfAnalysisSearchForm.analysisTarget,
  ),
  fiscalYearRange: parseAsArrayOf(parseAsInteger).withDefault(
    initialValueOfAnalysisSearchForm.fiscalYearRange,
  ),
  sheetType: parseAsStringLiteral(sheetTypeEnum.options).withDefault(
    initialValueOfAnalysisSearchForm.sheetType,
  ),
  q: parseAsString,
  isSearchTargetProjectName: parseAsBoolean.withDefault(false),
  cascader: parseAsString,
  corporateNumber: parseAsString,
  categories: parseAsArrayOf(parseAsStringLiteral(projectCategoryEnum.options)),
  implementationMethods: parseAsArrayOf(
    parseAsStringLiteral(implementationMethodEnum.options),
  ),
  accountingType: parseAsStringLiteral(accountingType.options),
  accountingTypeIds: parseAsArrayOf(parseAsString),
  projectNumbers: parseAsString,
  // // 事業年度（作成年度）
  startYear: parseAsInteger,
  endYear: parseAsInteger,
  // PS用
  organizationIds: parseAsArrayOf(parseAsString),
  otherResponsibleOrganizationIds: parseAsArrayOf(parseAsString),
  policyIds: parseAsArrayOf(parseAsString),
  expenditureBudgetPurposeIds: parseAsArrayOf(parseAsString),
  aggregationType: parseAsStringLiteral(
    aggregationTypeEnum.options,
  ).withDefault(initialValueOfAnalysisSearchForm.aggregationType),
  aggregationTargetType: parseAsStringLiteral(
    aggregationTargetTypeEnum.options,
  ).withDefault(initialValueOfAnalysisSearchForm.aggregationTargetType),
  analysisAxis: parseAsStringLiteral(analysisAxisEnum.options).withDefault(
    initialValueOfAnalysisSearchForm.analysisAxis,
  ),
};

const useAnalysisSearchQueryStates = () => {
  const [searchQueryStates, setSearchQueryStates] =
    useQueryStates(analysisSearchNuqs);
  return { searchQueryStates, setSearchQueryStates };
};

export type AnalysisSearchQueryStates = ReturnType<
  typeof useAnalysisSearchQueryStates
>['searchQueryStates'];
